import { Component, Inject, OnInit, OnDestroy } from '@angular/core'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog
} from '@angular/material/dialog'
import { TranslateService } from '@ngx-translate/core'
import { ToastrService } from 'ngx-toastr'
import { takeWhile } from 'rxjs'
import { HelperService } from '../../services/helper.service'
import { LookupService } from '../../services/lookup.service'
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component'
import { FrequencyType } from 'src/app/modules/control/models/frequency'
import { ControlService } from 'src/app/modules/control/services/control.service'
import { PackageService } from 'src/app/modules/packages/service/package.service'
import { PackageService as MaturityPackages } from 'src/app/modules/maturity-packages/service/package.service'
import { EventManagementService } from 'src/app/modules/event-management/services/event-management.service'
import { formatDate } from '@angular/common'

import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { TranslatePipe } from '@ngx-translate/core'
import { MatDialogModule } from '@angular/material/dialog'
import { LoaderComponent } from '../loader/loader.component'
import { CustomSelectComponent } from '../custom-select/custom-select.component'
import { DatePickerComponent } from '../date-picker/date-picker.component'
import { MatFormFieldModule } from '@angular/material/form-field'

@Component({
  selector: 'app-frequency-scheduling',
  templateUrl: './frequency-scheduling.component.html',
  styleUrls: ['./frequency-scheduling.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslatePipe,
    MatDialogModule,
    LoaderComponent,
    CustomSelectComponent,
    DatePickerComponent,
    MatFormFieldModule
  ]
})
export class FrequencySchedulingComponent implements OnInit, OnDestroy {
  currentLanguage = localStorage.getItem('lang')

  title = ''
  message = ''
  subMessage = ''
  image = ''

  isLoading: boolean = false
  frequencyData: any

  form!: FormGroup

  private alive: boolean = true
  isEdit: boolean = false
  id: any
  selectedFrequency = 1
  frequencyType = FrequencyType

  selectedChoiceForMonthlyFrequency = 'c1'
  selectedChoiceForYearlyFrequency = 'c1'

  isActiveWeekCount = 0
  allActiveWeekCount = 0

  frequencyTypes: any[] = []

  parts: any[] = [
    { id: 1, nameEn: 'First', nameAr: 'الأول' },
    { id: 2, nameEn: 'Second', nameAr: 'الثاني' },
    { id: 3, nameEn: 'Third', nameAr: 'الثالث' },
    { id: 4, nameEn: 'Fourth', nameAr: 'الرابع' },
    { id: 5, nameEn: 'Last', nameAr: 'الأخير' }
  ]

  // days: any[] = [
  //   { id: 1, nameEn: 'Sunday', nameAr: 'الأحد' },
  //   { id: 2, nameEn: 'Monday', nameAr: 'الإثنين' },
  //   { id: 3, nameEn: 'Tuesday', nameAr: 'الثلاثاء' },
  //   { id: 4, nameEn: 'Wednesday', nameAr: 'الأربعاء' },
  //   { id: 5, nameEn: 'Thursday', nameAr: 'الخميس' }
  // ]

  weeks: any[] = [
    {
      id: 0,
      nameEn: 'S',
      nameAr: 'أح',
      label: 'sun',
      fullNameEn: 'Sunday',
      fullNameAr: 'الأحد',
      isActive: false
    },
    {
      id: 1,
      nameEn: 'M',
      nameAr: 'إث',
      label: 'mon',
      fullNameEn: 'Monday',
      fullNameAr: 'الإثنين',
      isActive: false
    },
    {
      id: 2,
      nameEn: 'T',
      nameAr: 'ث',
      label: 'tue',
      fullNameEn: 'Tuesday',
      fullNameAr: 'الثلاثاء',
      isActive: false
    },
    {
      id: 3,
      nameEn: 'W',
      nameAr: 'أر',
      label: 'wen',
      fullNameEn: 'Wednesday',
      fullNameAr: 'الأربعاء',
      isActive: false
    },
    {
      id: 4,
      nameEn: 'TH',
      nameAr: 'خ',
      label: 'thu',
      fullNameEn: 'Thursday',
      fullNameAr: 'الخميس',
      isActive: false
    },
    {
      id: 5,
      nameEn: 'F',
      nameAr: 'ج',
      label: 'fri',
      fullNameEn: 'Friday',
      fullNameAr: 'الجمعة',
      isActive: false
    },
    {
      id: 6,
      nameEn: 'S',
      nameAr: 'س',
      label: 'sat',
      fullNameEn: 'Saturday',
      fullNameAr: 'السبت',
      isActive: true
    }
  ]

  months: any[] = [
    { id: 1, nameEn: 'January', nameAr: 'يناير' },
    { id: 2, nameEn: 'February', nameAr: 'فبراير' },
    { id: 3, nameEn: 'March', nameAr: 'مارس' },
    { id: 4, nameEn: 'April', nameAr: 'أبريل' },
    { id: 5, nameEn: 'May', nameAr: 'مايو' },
    { id: 6, nameEn: 'June', nameAr: 'يونيو' },
    { id: 7, nameEn: 'July', nameAr: 'يوليو' },
    { id: 8, nameEn: 'August', nameAr: 'أغسطس' },
    { id: 9, nameEn: 'September', nameAr: 'سبتمبر' },
    { id: 10, nameEn: 'October', nameAr: 'أكتوبر' },
    { id: 11, nameEn: 'November', nameAr: 'نوفمبر' },
    { id: 12, nameEn: 'December', nameAr: 'ديسمبر' }
  ]

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private helperService: HelperService,
    private translate: TranslateService,
    private controlService: ControlService,
    private packageService: PackageService,
    private maturityPackageService: MaturityPackages,
    private eventService: EventManagementService,
    private lookupService: LookupService
  ) {}

  ngOnInit(): void {
    this.translate.onLangChange.subscribe(
      (lang) => (this.currentLanguage = lang.lang)
    )
    this.title = this.data.title
    this.id = this.data.id
    this.initForm()
    this.getFrequencyData()
    this.getFrequencyTypes()
  }

  getFrequencyTypes() {
    this.lookupService.getFrequencyTypesLookups().subscribe({
      next: (res: any) => {
        this.frequencyTypes = res?.Data
        if (!this.form.value.frequencyType) {
          this.form.patchValue({ frequencyType: res?.Data[0]?.id })
        }
      },
      error: (err: any) => {
        console.error('err is :', err)
      }
    })
  }

  initForm() {
    this.form = this.fb.group({
      frequencyType: [1],
      date: [null, [Validators.required]],
      time: [null, [Validators.required]],
      startDate: [null],
      endDate: [null],
      repeat: [1],
      ////////////////////////////////
      monthChoice: ['c1'],
      dayNumberMonthChoice: [1],
      partNumberMonthChoice: [1],
      dayNameMonthChoice: [1],
      /////////////////////////////
      yearChoice: ['c1'],
      monthChoiceFirstYearly: [1],
      dayNumFirstYearly: [1],
      partChoiceSecondYearly: [1],
      dayNameChoiceSecondYearly: [1],
      monthNameSecondYearly: [1]
    })
    this.form
      .get('startDate')
      ?.patchValue(this.helperService.getDashedDateWithoutTime(new Date()))
    this.form.get('frequencyType')?.valueChanges.subscribe((res) => {
      this.selectedFrequency = res
      this.changeFrequencyType()
    })
    this.form.get('monthChoice')?.valueChanges.subscribe((res) => {
      this.selectedChoiceForMonthlyFrequency = res
      this.changeChoiceMonthlyFrequency(res)
    })
    this.form.get('yearChoice')?.valueChanges.subscribe((res) => {
      this.selectedChoiceForYearlyFrequency = res
      this.changeChoiceYearlyFrequency(res)
    })
  }

  changeFrequencyType() {
    if (!this.frequencyData) {
      this.form.patchValue({
        date: null,
        time: null,
        endDate: null
      })
    }
    this.form.get('monthChoice')?.patchValue('c1')
    this.form.get('yearChoice')?.patchValue('c1')
    this.form.markAsUntouched()
    if (this.selectedFrequency === FrequencyType.Once) {
      this.form.get('startDate')?.clearValidators()
      this.form.get('endDate')?.clearValidators()
      this.form.get('date')?.addValidators([Validators.required])
    } else {
      this.form.get('startDate')?.addValidators([Validators.required])
      this.form.get('endDate')?.addValidators([Validators.required])
      this.form.get('date')?.clearValidators()
    }
    this.form.get('startDate')?.updateValueAndValidity()
    this.form.get('endDate')?.updateValueAndValidity()
    this.form.get('date')?.updateValueAndValidity()
  }

  changeChoiceMonthlyFrequency(value: string) {
    switch (value) {
      case 'c1':
        this.form.get('dayNumberMonthChoice')?.enable()
        this.form.get('partNumberMonthChoice')?.disable()
        this.form.get('dayNameMonthChoice')?.disable()
        break
      case 'c2':
        this.form.get('dayNumberMonthChoice')?.disable()
        this.form.get('partNumberMonthChoice')?.enable()
        this.form.get('dayNameMonthChoice')?.enable()
        break
      default:
        break
    }
    this.form.get('dayNumberMonthChoice')?.updateValueAndValidity()
    this.form.get('partNumberMonthChoice')?.updateValueAndValidity()
    this.form.get('dayNameMonthChoice')?.updateValueAndValidity()
  }
  changeChoiceYearlyFrequency(value: string) {
    switch (value) {
      case 'c1':
        this.form.get('monthChoiceFirstYearly')?.enable()
        this.form.get('dayNumFirstYearly')?.enable()
        this.form.get('partChoiceSecondYearly')?.disable()
        this.form.get('dayNameChoiceSecondYearly')?.disable()
        this.form.get('monthNameSecondYearly')?.disable()
        break
      case 'c2':
        this.form.get('monthChoiceFirstYearly')?.disable()
        this.form.get('dayNumFirstYearly')?.disable()
        this.form.get('partChoiceSecondYearly')?.enable()
        this.form.get('dayNameChoiceSecondYearly')?.enable()
        this.form.get('monthNameSecondYearly')?.enable()
        break
      default:
        break
    }
    this.form.get('monthChoiceFirstYearly')?.updateValueAndValidity()
    this.form.get('dayNumFirstYearly')?.updateValueAndValidity()
    this.form.get('partChoiceSecondYearly')?.updateValueAndValidity()
    this.form.get('dayNameChoiceSecondYearly')?.updateValueAndValidity()
    this.form.get('monthNameSecondYearly')?.updateValueAndValidity()
  }

  getFrequencyData() {
    let freqObs: any
    if (this.data.type && this.data.type === 'control') {
      freqObs = this.controlService.getReassesmentFrequencyByControlId(this.id)
    }
    if (this.data.type && this.data.type === 'maintenance') {
      freqObs = this.controlService.getMaintenanceFrequencyByControlId(this.id)
    }

    if (this.data.type && this.data.type === 'package') {
      freqObs = this.packageService.getFrequencyByPackageId(this.id)
    }
    if (this.data.type && this.data.type === 'maturity-package') {
      freqObs = this.maturityPackageService.getFrequencyByPackageId(this.id)
    }
    if (this.data.type && this.data.type === 'event') {
      freqObs = this.eventService.getFrequencyById(this.id)
    }
    if (this.data.type && this.data.type === 'AddEvent') {
      this.form.patchValue({ frequencyType: this.data.frequencyTypeId })
      if (
        this.data.frequencyTypeId === FrequencyType.Once &&
        this.data.dateOfOnce
      ) {
        this.form.patchValue({ date: this.data.dateOfOnce })
      }

      if (this.data.frequency) {
        // freqObs = this.data.frequency
        this.fetchFormData(this.data.frequency)
      }
    }
    if (freqObs) {
      freqObs.pipe(takeWhile(() => this.alive)).subscribe({
        next: (res: any) => {
          this.frequencyData = res?.Data
          this.fetchFormData(this.frequencyData)
        },
        error: (err: any) => {
          console.error('err is :', err)
          this.toastr.error(this.translate.instant('Msg-Error-happened'))
        }
      })
    }
  }

  selectDayFromWeeklyFrequency(week: any) {
    // احسب عدد الأيام النشطة حالياً
    this.isActiveWeekCount = this.weeks.filter((el) => el.isActive).length
    // تحقق مما إذا كان المستخدم يحاول إلغاء تفعيل آخر يوم نشط
    if (this.isActiveWeekCount === 1 && week.isActive) {
      // لا تقم بتغيير الحالة إذا كان هذا هو اليوم الوحيد النشط
      return
    }
    // إذا لم يكن هناك مشكلة، قم بتغيير حالة اليوم
    week.isActive = !week.isActive
    this.allActiveWeekCount = this.weeks.filter((el) => el.isActive).length
  }

  fetchFormData(data: any) {
    this.selectedFrequency = data?.frequencyTypeId
    const endDateFormated = this.helperService.changeDateFormat(
      new Date(data?.endDate)
    )
    const startDateFormated = this.helperService.changeDateFormat(
      new Date(data?.startDate)
    )
    this.form.patchValue({
      frequencyType: data?.frequencyTypeId,
      startDate: startDateFormated,
      endDate: endDateFormated,
      repeat: data?.repeatEvery,
      time: data?.time
    })
    switch (this.selectedFrequency) {
      case FrequencyType.Once:
        this.form.get('date')?.patchValue(startDateFormated)
        break
      case FrequencyType.Daily:
        break
      case FrequencyType.Weekly:
        this.weeks = this.weeks.map((el: any) => {
          return {
            ...el,
            isActive: (data?.weeklyDays as any[]).includes(el.id) ? true : false
          }
        })
        break
      case FrequencyType.Monthly:
        this.form.get('monthChoice')?.patchValue(data?.isOn ? 'c2' : 'c1')
        this.form.get('dayNumberMonthChoice')?.patchValue(data?.dayOfMonth || 1)
        this.form
          .get('partNumberMonthChoice')
          ?.patchValue(data?.weekNumber || 1)
        this.form.get('dayNameMonthChoice')?.patchValue(data?.weekDay || 1)
        break
      case FrequencyType.Yearly:
        this.form.get('yearChoice')?.patchValue(data?.isOn ? 'c2' : 'c1')
        this.form
          .get('monthChoiceFirstYearly')
          ?.patchValue(data?.months[0] || 1)
        this.form.get('dayNumFirstYearly')?.patchValue(data?.yearlyDay || 1)

        this.form
          .get('partChoiceSecondYearly')
          ?.patchValue(data?.weekNumber || 1)
        this.form
          .get('dayNameChoiceSecondYearly')
          ?.patchValue(data?.weekDay || 1)
        this.form.get('monthNameSecondYearly')?.patchValue(data?.months[0] || 1)

        break
      default:
        break
    }
  }

  blurEventToResetInputValueToOne(formControl: any) {
    const repeatValue = this.form.get(formControl)?.value
    if (!repeatValue) {
      this.form.get(formControl)?.patchValue(1)
    }
  }

  restrictNumberInput(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Tab',
      'Delete'
    ]
    const enteredKey = event.key
    const currentInput = (event.target as HTMLInputElement).value
    const proposedValue = currentInput + enteredKey

    // السماح بالمفاتيح المساعدة مثل باك سبيس والأسهم
    if (allowedKeys.includes(enteredKey)) {
      return
    }

    // السماح فقط بالأرقام
    if (!/^[0-9]$/.test(enteredKey)) {
      event.preventDefault()
      return
    }

    // منع الكتابة إذا كانت القيمة المقترحة أقل من 1 أو أكبر من 99
    const numericValue = parseInt(proposedValue, 10)
    if (numericValue < 1 || numericValue > 99) {
      event.preventDefault()
    }
  }

  checkNumberRange(event: Event): void {
    const inputElement = event.target as HTMLInputElement
    const value = parseInt(inputElement.value, 10)

    // إذا كانت القيمة أقل من 1 أو أكبر من 99 يتم تصحيحها
    if (value < 1) {
      inputElement.value = '1'
    } else if (value > 99) {
      inputElement.value = '99'
    }
  }

  submit() {
    const value = this.form.getRawValue()
    let data: any
    const endDateFormated = this.helperService.changeDateFormat(
      new Date(value?.endDate)
    )
    const startDateFormated = this.helperService.changeDateFormat(
      new Date(value?.startDate)
    )
    const dateFormated = this.helperService.changeDateFormat(
      new Date(value?.date)
    )
    switch (this.selectedFrequency) {
      case FrequencyType.Once:
        data = {
          startDate: dateFormated,
          endDate: dateFormated,
          time: value.time,
          frequencyTypeId: FrequencyType.Once
        }
        break
      case FrequencyType.Daily:
        data = {
          startDate: startDateFormated,
          endDate: endDateFormated,
          time: value.time,
          repeatEvery: value.repeat,
          frequencyTypeId: FrequencyType.Daily
        }
        break
      case FrequencyType.Weekly:
        data = {
          startDate: startDateFormated,
          endDate: endDateFormated,
          time: value.time,
          repeatEvery: value.repeat,
          frequencyTypeId: FrequencyType.Weekly,
          weeklyDays: this.weeks.filter((el) => el.isActive).map((el) => el.id)
        }
        break
      case FrequencyType.Monthly:
        data = {
          startDate: startDateFormated,
          endDate: endDateFormated,
          time: value.time,
          repeatEvery: value.repeat,
          frequencyTypeId: FrequencyType.Monthly
        }
        if (value.monthChoice === 'c1') {
          data.isOn = false
          data.dayOfMonth = value.dayNumberMonthChoice
        } else {
          data.isOn = true
          data.weekNumber = value.partNumberMonthChoice
          data.weekDay = value.dayNameMonthChoice
        }
        break
      case FrequencyType.Yearly:
        data = {
          startDate: startDateFormated,
          endDate: endDateFormated,
          time: value.time,
          repeatEvery: value.repeat,
          frequencyTypeId: FrequencyType.Yearly
        }
        if (value.yearChoice === 'c1') {
          data.isOn = false
          data.months = [value.monthChoiceFirstYearly]
          data.yearlyDay = value.dayNumFirstYearly
        } else {
          data.isOn = true
          data.weekNumber = value.partChoiceSecondYearly
          data.weekDay = value.dayNameChoiceSecondYearly
          data.months = [value.monthNameSecondYearly]
        }
        break
      default:
        data = null
        break
    }

    this.dialogRef.close(data)
  }

  get selectedPartNameInMonthlyFrequency(): string {
    const selectedId = this.form.get('partNumberMonthChoice')?.value
    const selectedItem = this.parts.find((item) => item.id === selectedId)
    return selectedItem
      ? this.currentLanguage === 'en'
        ? selectedItem.nameEn
        : selectedItem.nameAr
      : ''
  }
  get selectedDayNameInMonthlyFrequency(): string {
    const selectedId = this.form.get('dayNameMonthChoice')?.value
    const selectedItem = this.weeks.find((item) => item.id === selectedId)
    return selectedItem
      ? this.currentLanguage === 'en'
        ? selectedItem.fullNameEn
        : selectedItem.fullNameAr
      : ''
  }

  get selectedMonthNameInYearlyFrequencyFirstChoice(): string {
    const selectedId = this.form.get('monthChoiceFirstYearly')?.value
    const selectedItem = this.months.find((item) => item.id === selectedId)
    return selectedItem
      ? this.currentLanguage === 'en'
        ? selectedItem.nameEn
        : selectedItem.nameAr
      : ''
  }

  get selectedPartNameInYearlyFrequencySecondChoice(): string {
    const selectedId = this.form.get('partChoiceSecondYearly')?.value
    const selectedItem = this.parts.find((item) => item.id === selectedId)
    return selectedItem
      ? this.currentLanguage === 'en'
        ? selectedItem.nameEn
        : selectedItem.nameAr
      : ''
  }
  get selectedDayNameInYearlyFrequencySecondChoice(): string {
    const selectedId = this.form.get('dayNameChoiceSecondYearly')?.value
    const selectedItem = this.weeks.find((item) => item.id === selectedId)
    return selectedItem
      ? this.currentLanguage === 'en'
        ? selectedItem.fullNameEn
        : selectedItem.fullNameAr
      : ''
  }
  get selectedMonthNameInYearlyFrequencySecondChoice(): string {
    const selectedId = this.form.get('monthNameSecondYearly')?.value
    const selectedItem = this.months.find((item) => item.id === selectedId)
    return selectedItem
      ? this.currentLanguage === 'en'
        ? selectedItem.nameEn
        : selectedItem.nameAr
      : ''
  }

  ngOnDestroy(): void {
    this.alive = false
  }

  deleteNextDate() {
    this.dialog
      .open(ConfirmDialogComponent, {
        disableClose: true,
        data: {
          title: 'Delete-Item',
          message: 'Msg-Confirm-Delete-Title',
          subMessage: 'Msg-Confirm-Delete-Msg',
          image: 'delete-icon.png'
        }
      })
      .afterClosed()
      .subscribe(() => {})
  }
  getFormattedTime(time: string): string {
    if (!time) return ''
    const date = new Date(`1970-01-01T${time}`)
    return formatDate(date, 'h:mm a', 'en-US')
  }
  private formatTime(date: Date): string {
    return date.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    })
  }
}
